export const normalizeAppName = (appName: string): string => {
  return appName.replace(/\s+/g, '').toLowerCase();
};
